import { MRT_Cell, MRT_ColumnDef } from "material-react-table";
import { Accessor } from "../../../../utilities/types";
import { Checkbox, FormControlLabel } from "@mui/material";
import type { BaseDataModel } from "../../../../models";

export const checkboxMultiselectColumn = <T extends BaseDataModel>(
	header: string,
	value: string,
	accessorKeyOrFn?: Accessor<string[], T>,
) =>
	({
		id: header.toLowerCase(),

		accessorFn: (row) =>
			typeof accessorKeyOrFn === "function"
				? accessorKeyOrFn(row)
				: ((accessorKeyOrFn ? ((row[accessorKeyOrFn] as string[] | undefined) ?? []) : []) as string[]),

		header: value,
		size: 100,

		// filterVariant: 'checkbox',
		Filter: ({ column }: { column: MRT_ColumnDef<T, unknown> }) => (
			<FormControlLabel
				control={
					<Checkbox
						// @ts-ignore
						checked={column.getFilterValue() === "true"}
						// @ts-ignore
						color={column.getFilterValue() === undefined ? "default" : "primary"}
						// @ts-ignore
						indeterminate={column.getFilterValue() === undefined}
						size="small"
						onChange={() => {
							// @ts-ignore
							column.setFilterValue(
								// @ts-ignore
								column.getFilterValue() === undefined
									? "true"
									: // @ts-ignore
										column.getFilterValue() === "true"
										? "false"
										: undefined,
							);
						}}
						sx={() => ({
							height: "2.5rem",
							width: "2.5rem",
						})}
					/>
				}
				disableTypography
				// @ts-ignore
				label={column.getFilterValue() === undefined ? "Yes & No" : column.getFilterValue() === "true" ? "Yes" : "No"}
				sx={{ color: "text.secondary", fontWeight: "normal", mt: "-4px" }}
				title={undefined}
			/>
		),

		Cell: ({ cell }: { cell: MRT_Cell<T, string[]> }) => {
			const values = cell.getValue<string[]>();
			// console.log(values);
			return <Checkbox style={{ margin: 0, padding: 0 }} checked={values.includes(value)} />;
		},
	}) as MRT_ColumnDef<T>;
